import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { LeadHistoryPanel } from '../../components/speedToLead/LeadHistoryPanel';
import type { LeadOutcome } from '../../types/leadOutcome.js';
import { confirmCallOutcome, fetchLeadHistory, fetchRecordingUrl } from './api';

// STAGE 4C (Kyck): "Lead history" for a text conversation, opened from the Lead Bot page. The panel mounts, and so loads,
// only when the button is pressed. The server resolves the lead from the conversation id (the phone never travels).
export function ConversationLeadHistory({ conversationId, confirmOutcome }: { conversationId: string; /** Confirms an AI-suggested outcome on one of the lead's conversations. */ confirmOutcome?: (conversationId: string, code: LeadOutcome) => Promise<void> }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-2" data-testid="conversation-lead-history">
      <Button type="button" variant="outline" size="sm" aria-expanded={open} onClick={() => setOpen(!open)}>{open ? 'Hide lead history' : 'Lead history'}</Button>
      {open && (
        <div className="max-h-[60vh] overflow-y-auto">
          <LeadHistoryPanel
            load={(cursor) => fetchLeadHistory({ conversation: conversationId }, cursor)}
            confirmConversationOutcome={confirmOutcome}
            callHandlers={{
              loadPlayUrl: async (kind, id) => (await fetchRecordingUrl(kind, id)).url,
              onConfirmOutcome: async (kind, id, outcome) => { await confirmCallOutcome(kind, id, outcome); },
            }}
          />
        </div>
      )}
    </div>
  );
}
